export var valuesPayloadKeyEnum = ["Undefined", "CategoryName", "CategoryId", "PostId", "GameId", "GameType", "Points", "NewPostId", "PostType", "Rating", "ErrorMessage", "SearchStrings"];
/*

*/ 
//# sourceMappingURL=PayloadKeyEnum.js.map